import { render, staticRenderFns } from "./tourTypeConfig.vue?vue&type=template&id=b3b17cb6&scoped=true&"
import script from "./tourTypeConfig.vue?vue&type=script&lang=js&"
export * from "./tourTypeConfig.vue?vue&type=script&lang=js&"
import style0 from "./tourTypeConfig.vue?vue&type=style&index=0&id=b3b17cb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b17cb6",
  null
  
)

export default component.exports